module.exports = __webpack_public_path__ + "static/media/garbageTruck_turquoise.cbe16be4.svg";